import { Injectable } from '@angular/core'

@Injectable()
export class Configuration {

    public static readonly junoProduction = true
    public static readonly junoProductionPublicKey = 'F003F71D4412E496320955E806D57328A25A7990F6CE93C828F1E58F3EA01A1603DD370E05F186B0' //PRODUCTION
    public static readonly junoSandboxPublicKey = '3C2DB3FA9E29E0B7CB468AB6CA0278676D4F16D940AEC338FAF9E823183BB2BA' //SANDBOX

    public static readonly sealApiUrl = 'https://api.polen.com.br/'
    // public static readonly sealApiUrl = 'https://sandbox.polen.com.br/'

    public static version = "v18.0 -" + (Configuration.junoProduction ? 'prod' : 'dev') //Visualização correta Fabrica Camisaria
    public static GetApiUrl() {
        return 'https://storeapi.polen.com.br/';
        //return 'https://storeapibeta.polen.com.br/';
        //return 'http://fernandoott6d88:49784/'
        //return 'http://35.222.70.116/'
        //return 'http://localhost:49787/'

        // console.log(window.location.href)
        // if (window.location.href.indexOf('localhost')){
        //     console.log('fernandott6d88')
        //     return 'http://fernandoott6d88:49784/'
        // }
        // else{
        //     console.log('storeapi')
        //     return 'https://storeapi.opolen.com.br/';
        // }
    }

    public static apiUrl = Configuration.GetApiUrl();
    public static storeApiUrl = "https://storeapi.opolen.com.br/";

    //public static readonly storePanelUrl = 'http://localhost:4200/#/'
    public static readonly storePanelUrl = 'https://painel.polen.com.br/#/'
    //public static readonly storePanelUrl = 'https://painelprod.polen.com.br/#/'

    public static readonly staticUrl = 'https://static.polen.app.br/'

    constructor() {
        // if (window.location.href.indexOf('localhost')){
        //     Configuration.apiUrl = 'http://fernandoott6d88:49784/'
        // }
        // else{
        //     Configuration.apiUrl = 'https://storeapi.opolen.com.br/';
        // }
    }

    public static InvoiceUrl(statementId: any): string {
        return '/#/fatura/' + statementId
    }
}
